<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m12.5 22-.2-3H12q-3.6 0-6-2.5a8 8 0 0 1-2.5-6q0-3.6 2.5-6A8 8 0 0 1 12 2a8 8 0 0 1 6 2.5 9 9 0 0 1 2.5 6q0 1.9-.6 3.6a13 13 0 0 1-4.2 5.9q-1.4 1.1-3.2 2m-.5-6q.4 0 .7-.3t.3-.7l-.3-.8-.7-.3-.7.3a1 1 0 0 0-.4.8l.3.7q.4.3.8.3m-.7-3.2h1.4l.2-1 1-1.2q.4-.3.7-1 .3-.5.3-1 0-1.3-.9-2T12 6q-1 0-1.8.6T9 8.1l1.4.6q0-.5.5-.9.3-.4 1-.4t1 .4.3.8l-.2.8-.6.7-1 1.1q-.2.5-.2 1.6"
    />
  </svg>
</template>
